'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

var _BestSeller = require('../best-seller/BestSeller');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Collection Carousel
 *    Scripts for the Collection Carousel section. Creates a slick slide for
 *    smaller devices.
 *
 *  Version:
 *    1.0.0 - 2020/03/03
 */

var CONTAINER_SELECTOR = '[data-collection-carousel-container]';
var CAROUSEL_SELECTOR = '[data-collection-carousel]';

var CollectionCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(CollectionCarousel, _CarouselSection);

  function CollectionCarousel(container) {
    (0, _classCallCheck3.default)(this, CollectionCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CollectionCarousel.__proto__ || Object.getPrototypeOf(CollectionCarousel)).call(this, container));

    _this.carouselSelector = container.find(CAROUSEL_SELECTOR);

    _this.addToCart = new _BestSeller.BestSeller(container);
    _this.slick = _this.initCarousel(_this.carouselSelector);
    return _this;
  }

  return CollectionCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, CollectionCarousel);